module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 112.18 117.97\"><title></title><rect x=\"4\" y=\"28.26\" width=\"85.71\" height=\"85.71\" style=\"fill:#fff;stroke:#edaa24;stroke-miterlimit:10;stroke-width:6px\"></rect><polygon points=\"81.25 1.73 109.68 1.73 40.92 105.5 14.68 62.7 28.39 39.71 44.05 65.48 81.25 1.73\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/svg/checkbox_on.svg
// module id = 8/3G
// module chunks = 0